$('body').hide();

let url = window.location;

let searchString = url.search;
if(searchString.startsWith("?sso=true&?")){
  searchString = searchString.replace("?sso=true&?", "?sso=true&");
}
  let params = new URLSearchParams(searchString);

function generatePassword() {
    var length = 8,
        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
}

if(url.pathname === "/account/register" || url.pathname === "/en/account/register") {
  if(params.has("sso")) {
    var mo_param_title = params.get("sso");
    if(mo_param_title === "true") {
      $(".btn-registers").toggleClass("active");
      sessionStorage.removeItem("accountType");
      sessionStorage.setItem("sso", params.get("sso"));
      
    }
  }
  
  if(params.has("email")) {

    sessionStorage.setItem("email", params.get("email"));
    $("input[name='customer[email]']").css('pointer-events','none');
  }

  if(sessionStorage.getItem("email") === 'null' || sessionStorage.getItem("email") === '') {
    sessionStorage.removeItem("email");
    $("input[name='customer[email]']").css('pointer-events','');
  } else {
    $("input[name='customer[email]']").val(sessionStorage.getItem("email"));
    $("input[name='customer[email]']").css('pointer-events','none');
  }

  if(sessionStorage.getItem("sso") == "true") {
    $("input[name='customer[password]']").parent().hide();
    $("input[name='customer[password]']").val(generatePassword());
  }
}

if(sessionStorage.getItem("email") === null) {
    $("input[name='customer[email]']").css('pointer-events','');
}

if(!(url.pathname === "/account/register" || url.pathname === "/en/account/register")) {
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("sso");
    $("input[name='customer[email]']").css('pointer-events','');
}


$( window ).on( "load", function() {
  $('body').show();
} );
